import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import BCXButton from '@/components/molecules/BCXButton.vue';
import useMeetingScheduler from '@/components/meeting-scheduler/composables/useMeetingScheduler';
import useI18n from '@/mixins/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'MeetingFooter',
  setup(__props) {

const { t } = useI18n();

const {
  fetchCreateMeeting,
  form,
  refreshCalendar,
  showMeeting,
  backToCalendar,
  isCreateMeetingLoading
} = useMeetingScheduler();

const isFormValid = computed(() => !!form.value.participantId
  && !!form.value.subject
  && form.value.timeSlots.length > 0);

async function onCancel() {
  backToCalendar();
}

async function onSend() {
  const newInvitation = await fetchCreateMeeting(form.value);
  showMeeting(newInvitation, new Date(newInvitation?.timeSlots[0].start));

  await refreshCalendar();
}

return { __sfc: true,t, fetchCreateMeeting, form, refreshCalendar, showMeeting, backToCalendar, isCreateMeetingLoading, isFormValid, onCancel, onSend, BCXButton }
}

})